var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center w-100 d-flex justify-content-center align-items-center",staticStyle:{"height":"500px"}},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"variant":"primary","label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }